import React from "react";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function HeaderSkeleton() {
  return (
    <div className="header-skeleton">
      <div className="logo-skeleton">
        <Skeleton height={50} width={190}  />
      </div>
      <div className="header-right-skeleton">
        <Skeleton
          circle
          containerClassName="header-icon"
          width={40}
          height={40}
        />
        <Skeleton
          circle
          containerClassName="header-icon"
          width={40}
          height={40}
        />
        <Skeleton height={30} width={90}  />
        <Skeleton
          circle
          containerClassName="header-icon"
          width={40}
          height={40}
        />
      </div>
    </div>
  );
}

export default HeaderSkeleton;
